import AnalyticsApi from '../api/AnalyticsApi';
import AnalyticsConstants from '../constants/AnalyticsConstants';

function fetchDataLayer({ localBranch } = { localBranch: null }) {
  return {
    types: [
      AnalyticsConstants.FETCH_DATALAYER_REQUEST,
      AnalyticsConstants.FETCH_DATALAYER_SUCCESS,
      AnalyticsConstants.FETCH_DATALAYER_FAILURE
    ],
    apiRequest: (_state, client) => AnalyticsApi.fetchDataLayer({ localBranch }, client)
  };
}

function setContext(contextName, context) {
  return {
    type: AnalyticsConstants.SET_CONTEXT,
    contextName,
    context
  };
}

export default {
  fetchDataLayer,
  setContext
};
